import { render, staticRenderFns } from "./OidcUsers.vue?vue&type=template&id=28bea13c&"
import script from "./OidcUsers.vue?vue&type=script&lang=js&"
export * from "./OidcUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports